module.exports = __webpack_public_path__ + "static/media/rs1.29c26d86.png";